(() => {
  function activate(tab,selector) {
    const group=tab.closest('[role="tablist"]');
    group.querySelectorAll(selector).forEach(button=>{
      const selected=button===tab;
      button.setAttribute('aria-selected',String(selected));
      button.tabIndex=selected?0:-1;
      const panel=document.getElementById(button.getAttribute('aria-controls'));
      if(panel)panel.hidden=!selected;
    });
    const gallery=tab.closest('.p-gallery-v2');
    if(gallery){const tabs=[...group.querySelectorAll(selector)];gallery.querySelector('[data-gallery-caption]').textContent=`${tabs.indexOf(tab)+1} / ${tabs.length} — ${tab.dataset.galleryCaptionText}`;}
  }
  function stepGallery(gallery,step){
    const tabs=[...gallery.querySelectorAll('[data-prime-tab]')],index=tabs.findIndex(tab=>tab.getAttribute('aria-selected')==='true');
    if(!tabs.length)return;
    activate(tabs[(index+step+tabs.length)%tabs.length],'[role="tab"]');
  }
  document.addEventListener('click',event=>{
    const tab=event.target.closest('[data-prime-tab],[data-discover-tab]');
    if(tab) activate(tab,'[role="tab"]');
    const galleryStep=event.target.closest('[data-gallery-step]');
    if(galleryStep) stepGallery(galleryStep.closest('.p-gallery-v2'),Number(galleryStep.dataset.galleryStep));
    const bundle=event.target.closest('[data-bundle]');
    if(bundle&&!bundle.disabled){
      const section=bundle.closest('[data-prime]');
      section.querySelectorAll('[data-bundle]').forEach(button=>{button.classList.toggle('is-selected',button===bundle);button.setAttribute('aria-pressed',String(button===bundle));});
      const input=section.querySelector('[data-bundle-quantity]');
      if(input) input.value=bundle.dataset.bundle;
      const quantity=Number(bundle.dataset.bundle);
      section.querySelectorAll('[data-prime-gift]').forEach(field=>{field.disabled=quantity<(field.dataset.primeGift==='kitchen'?3:5);});
      const note=section.querySelector('[data-first-order-gifts]');
      if(note){note.hidden=quantity===1;note.textContent=quantity===5?'Both ebooks free with your first order':'Free cookbook with your first order';}
      const now=section.querySelector('[data-cta-now]'),compare=section.querySelector('[data-cta-compare]');
      if(now) now.textContent=bundle.dataset.price;
      if(compare){compare.textContent=bundle.dataset.compare;compare.hidden=!bundle.dataset.compare;}
    }
  });
  document.addEventListener('submit',async event=>{
    const form=event.target.closest('.p-subscription-form');
    if(!form)return;
    event.preventDefault();
    if(form.dataset.submitting==='true')return;
    const section=form.closest('[data-prime]');
    const quantity=Number(form.querySelector('[data-bundle-quantity]').value);
    const variant=form.querySelector('[data-prime-variant]')?.value;
    const sellingPlan=form.querySelector('[data-prime-selling-plan]')?.value;
    const error=section.querySelector('[data-prime-cart-error]');
    const button=form.querySelector('[type="submit"]');
    error.hidden=true;
    if(!variant||!sellingPlan||![1,3,5].includes(quantity)||(quantity>=3&&!section.dataset.kitchenGift)||(quantity===5&&!section.dataset.movementGift)){
      error.textContent='This offer is temporarily unavailable. Please refresh the page and try again.';error.hidden=false;return;
    }
    // Only Natto receives a selling plan. Digital gifts are one-time cart lines.
    const items=[{id:variant,quantity,selling_plan:sellingPlan}];
    if(quantity>=3)items.push({id:section.dataset.kitchenGift,quantity:1,_bundleGift:true});
    if(quantity===5)items.push({id:section.dataset.movementGift,quantity:1,_bundleGift:true});
    const label=button.innerHTML;
    form.dataset.submitting='true';button.disabled=true;button.textContent='ADDING…';
    try{
      if(window.CoppiceCart){await window.CoppiceCart.add(items,button);form.dataset.submitting='false';button.disabled=false;button.innerHTML=label;return;}
      items.forEach(item=>delete item._bundleGift);
      const root=window.Shopify?.routes?.root||'/';
      // Appstle's custom-request flag preserves the explicit plan when its widget is off.
      const response=await fetch(root+'cart/add.js?appstle=true',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      const result=await response.json();
      if(!response.ok)throw new Error(result.description||'Unable to add this offer. Please try again.');
      window.location.assign(root+'cart');
    }catch(reason){
      error.textContent=reason.message||'Unable to add this offer. Please try again.';error.hidden=false;
      form.dataset.submitting='false';button.disabled=false;button.innerHTML=label;
    }
  });
  document.addEventListener('keydown',event=>{
    if(!event.target.matches('[data-prime-tab],[data-discover-tab]')) return;
    const tabs=[...event.target.parentElement.querySelectorAll('[role="tab"]')],index=tabs.indexOf(event.target);
    const next=event.key==='ArrowRight'?tabs[(index+1)%tabs.length]:event.key==='ArrowLeft'?tabs[(index+tabs.length-1)%tabs.length]:event.key==='Home'?tabs[0]:event.key==='End'?tabs[tabs.length-1]:null;
    if(next){event.preventDefault();activate(next,'[role="tab"]');next.focus();}
  });
  let swipeStart=null;
  document.addEventListener('pointerdown',event=>{
    const area=event.target.closest('[data-gallery-swipe]');
    swipeStart=area?{area,x:event.clientX,y:event.clientY}:null;
  },{passive:true});
  document.addEventListener('pointerup',event=>{
    if(!swipeStart)return;
    const {area,x,y}=swipeStart;swipeStart=null;
    const dx=event.clientX-x,dy=event.clientY-y;
    if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.4)stepGallery(area.closest('.p-gallery-v2'),dx<0?1:-1);
  },{passive:true});
  document.addEventListener('pointercancel',()=>{swipeStart=null;},{passive:true});
  const observers=new WeakMap();
  function init(root){root.querySelectorAll('[data-prime]').forEach(section=>{
    if(observers.has(section)) return;
    const sticky=section.querySelector('[data-prime-sticky]'),buyBox=section.querySelector('.p-purchase');
    if(!sticky||!buyBox||!('IntersectionObserver' in window)) return;
    const target=buyBox.querySelector('.p-add')||buyBox;const update=()=>{sticky.hidden=target.getBoundingClientRect().bottom>0;};let ticking=false;window.addEventListener('scroll',()=>{if(ticking)return;ticking=true;requestAnimationFrame(()=>{ticking=false;update();});},{passive:true});window.addEventListener('resize',update,{passive:true});update();const observer={observe(){}};
    observer.observe(target);observers.set(section,observer);
  });}
  document.addEventListener('shopify:block:select',event=>{
    const block=event.target;
    const panel=block.closest('[role="tabpanel"]');
    if(panel){const tab=document.getElementById(panel.getAttribute('aria-labelledby'));if(tab)activate(tab,'[role="tab"]');}
    const details=block.closest('details');if(details)details.open=true;
    const card=block.closest('.p-community-card,.p-benefit-grid article');
    if(card)card.scrollIntoView({block:'nearest',inline:'center',behavior:'instant'});
  });
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-prime]').forEach(section=>observers.get(section)?.disconnect()));
})();
